
const burgerBtn = document.querySelector('.burger-btn');
const searchBtn = document.querySelector('.search-btn');

const nav = document.querySelector('.header__nav');
const burgerMenu = document.querySelector('.burger-menu');
const headerTop = document.querySelector('.header__top');

burgerBtn.addEventListener('click', () => {
  burgerBtn.querySelector('.burger-btn__show-icon').classList.toggle('hidden');
  burgerBtn.querySelector('.burger-btn__close-icon').classList.toggle('hidden');
  searchBtn.classList.toggle('hidden');
  nav.classList.toggle('hidden');

  const headerTopIndex = headerTop.style.zIndex;
  if (headerTopIndex == 1 || !headerTopIndex) {
    headerTop.style.zIndex = 105;
  } else {
    headerTop.style.zIndex = 1;
  }

  burgerMenu.classList.toggle('burger-menu_show');
  document.body.classList.toggle('o-hidden');
});